













import { Component, Prop, Vue } from 'vue-property-decorator';
// @ts-ignore
import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';
import Charts from 'fusioncharts/fusioncharts.charts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';


// @ts-ignore
FusionCharts.options.creditLabel = false;

// register VueFusionCharts component
Vue.use(VueFusionCharts, FusionCharts, Charts, FusionTheme);

interface RefsInterface {
    chart: Vue
}

@Component({
    name: 'StackedColumnGraph',
})
export default class StackedColumnGraph extends Vue {
    public $refs!: Vue['$refs'] & RefsInterface;
    @Prop({required: true}) protected dataSource!: object;

    protected config = {
        type: 'stackedcolumn2d',
        width: '100%',
        height: '450',
        dataFormat: 'json',
    };

    protected beforeAnimation() {
        this.$refs.chart.$el.querySelectorAll('rect').forEach((element) => {
            element.setAttribute('rx', '7');
            element.setAttribute('ry', '7');
        });
    }
}
